class StoreLanguage {
  constructor (
    id = undefined,
    name,
    code
  ) {
    this.id = id
    this.name = name
    this.code = code
  }

  toNormalizedRESTModel () {
    return ({
      // id is read-only
      name: this.name,
      code: this.code
    })
  }

  static FromNormalizedRESTModel ({
    id,
    name,
    code
  }) {
    return new StoreLanguage(
      id,
      name,
      code
    )
  }

  toJSON () {
    return {
      id: this.id,
      name: this.name,
      code: this.code
    }
  }

  static FromJSON (json) {
    if (!json || typeof json !== 'object') {
      return null
    }

    const { id, name, code } = json
    return new StoreLanguage(
      id,
      name,
      code
    )
  }
}

export default StoreLanguage
